export const MINUTES_ADVANCE_RANGE: { [key: string]: string } = {
  '1': '1 minute',
  '5': '5 minutes',
  '10': '10 minutes',
  '20': '20 minutes',
  '30': '30 minutes',
  '60': '1 hour',
  '120': '2 hours',
};
